import { IError } from 'ts/login/interfaces';
import * as React from 'react';
import { Button, Colors, Text } from '@origin-digital/style-guide';
import { PasswordInput } from 'ts/login/components/PasswordInput/PasswordInput';
import { LoginErrorBox } from 'ts/login/components/LoginErrorBox';
import { CaptchaDisclaimer } from 'ts/login/components/CaptchaDisclaimer';
import { UsernameInput } from 'ts/login/components/UsernameInput/UsernameInput';
import styled from 'styled-components';
import { Loader } from 'ts/components/Loader';
import { IFramePage } from './IFramePage';
import { Heading } from 'ts/components/Heading';
import { Box } from '@origin-digital/layout';

interface IFrameLoginViewProps {
  checkingUser: boolean;
  disableUsernameIcon: boolean;
  username: string;
  password: string;
  loginError: IError;
  usernameError: string;
  loginSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  passwordError: string;
  onPasswordChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  loading: boolean;
  handleUsernameOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleUsernameOnBlur: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onContinueWithoutLoginClick: () => void;
}

const IFrameLoginView: React.FC<IFrameLoginViewProps> = ({
  checkingUser,
  disableUsernameIcon,
  loading,
  username,
  password,
  usernameError,
  loginError,
  loginSubmit,
  passwordError,
  onPasswordChange,
  handleUsernameOnChange,
  handleUsernameOnBlur,
  onContinueWithoutLoginClick,
}) => {
  return (
    <IFramePage>
      {loading ? (
        <Loader height="300px" />
      ) : (
        <>
          <LoginErrorBox error={loginError} />
          <Heading text="Your My Account details" />
          <form onSubmit={loginSubmit} noValidate={true}>
            <UsernameInput
              id="username"
              error={usernameError}
              onChange={handleUsernameOnChange}
              onBlur={handleUsernameOnBlur}
              value={username}
              label="Email address"
              checkingUser={checkingUser}
              disableIcon={disableUsernameIcon}
            />
            <PasswordInput
              label={'Password'}
              value={password}
              error={passwordError}
              onChange={onPasswordChange}
            />
            <Button type="submit" data-id="login" text="Log in" name="login" block={true} />
          </form>
          <Box display="flex" alignItems="center" paddingY={6}>
            <Button
              block={true}
              data-id="login-continue-without-login"
              kind={'secondary'}
              text="I don't have my login details"
              onClick={onContinueWithoutLoginClick}
            />
          </Box>
          <Box display="flex" alignItems="center" marginBottom={6}>
            <Text>
              If you don’t have your details, don’t worry. You can continue and get your plan
              without logging in.
            </Text>
          </Box>
          <HorizontalLine />
          <CaptchaDisclaimer />
        </>
      )}
    </IFramePage>
  );
};

const HorizontalLine = styled.div`
  border-bottom: 1px solid ${Colors.GREY16};
  width: 100%;
`;

export { IFrameLoginView };
